import { useState, FC } from 'react';
import { useSnackbar } from 'notistack';
import { Stack, Box, Fade } from '@mui/material';
import { Modal, Loader, ModalSaveSection, TextField } from '../../../../../components';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { createFieldWalkthroughManagementLocation } from '../../../../../fetch/field-walkthrough-location-management';
import { useHistory } from 'react-router-dom';

interface IAddLocationModal {
  open: boolean;
  onClose: () => void;
}
const AddLocationSchema = Yup.object().shape({
  name: Yup.string().required('Required')
});

export const AddLocationModal: FC<IAddLocationModal> = ({ open, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isSaving, setIsSaving] = useState(false);
  const history = useHistory();

  const handleClose = () => {
    onClose();
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        name: ''
      }}
      validationSchema={AddLocationSchema}
      onSubmit={async (values, actions) => {
        try {
          setIsSaving(true);

          const data = {
            name: values.name
          };

          const newLocationId = await createFieldWalkthroughManagementLocation(data);

          enqueueSnackbar('Location Created!', {
            variant: 'success'
          });

          onClose();
          actions.resetForm();
          setIsSaving(false);
          history.push(`/production/field-walkthroughs/list-management/${newLocationId}`);
        } catch (error) {
          console.log(error);
          enqueueSnackbar(error?.response?.data?.Detail ?? 'Location was not created', {
            variant: 'error'
          });
        }
      }}
    >
      {({ values, handleSubmit, handleBlur }) => {
        return (
          <Modal open={open} onClose={handleClose} maxWidth="xs" title="Create New Location">
            <Fade in={open}>
              <div>
                {isSaving && <Loader type="overlay" position="centered" />}
                <Box mt={1}>
                  <Stack gap={1}>
                    <TextField
                      fullWidth
                      required
                      variant="outlined"
                      autoComplete="nope"
                      label="Name"
                      name="name"
                      value={values.name}
                      onBlur={handleBlur}
                      size="small"
                    />
                  </Stack>
                </Box>
                <ModalSaveSection
                  saveButtonText="Submit"
                  isSaveDisabled={isSaving}
                  handleCancel={handleClose}
                  handleSave={handleSubmit}
                />
              </div>
            </Fade>
          </Modal>
        );
      }}
    </Formik>
  );
};
